<div class="ideals-chips">
  <ideals-input-control-wrapper #wrapper=wrapper
                                [id]="id"
                                [errorList]="errorList"
                                [errorsToShow]="errorsToShow"
                                [canShowError]="canShowError">
    <div class="ideals-input-element"
         [formGroup]="$any(formControl)"
         data-ideals="addEmailsContainer">
      @for (control of formControl.controls; track control) {
        <ideals-chip [formControl]="$any(control)"
                     [formControlName]="$index"
                     (edited)="onEdit()"
                     (crossClick)="onRemove($event)"
                     data-ideals="chip">
        </ideals-chip>
      }

      <input class="ideals-chips-input"
             autocomplete="off"
             type="text"
             [attr.data-chip-editor]="componentId"
             [placeholder]="currentPlaceholder"
             (blur)="onBlur($event)"
             (keydown)="onKeydown($event)"
             (paste)="paste($event)"
             data-ideals="newUserEmail"/>
    </div>
  </ideals-input-control-wrapper>
</div>
